module.exports = __webpack_public_path__ + "br.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/br.svg
// module id = 463
// module chunks = 0